/**
 * Main shell layout component.
 */

import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Topbar } from './topbar';
import './shell.scss';

export function Shell() {
  return (
    <div className="shell">
      <Sidebar />
      <div className="shell__content">
        <Topbar />
        <main className="shell__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

